class AnimationSubs2ColsDesplegable {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleSubs2ColsDesplegable = this.sectionsContainer.querySelectorAll('.subs-2-cols-desplegable');
		
		if (!this.$moduleSubs2ColsDesplegable.length)
			return;
		
		this.$moduleSubs2ColsDesplegableElements = [];
		this.$moduleSubs2ColsDesplegable.forEach(module => {
			this.$moduleSubs2ColsDesplegableElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleSubs2ColsDesplegable.forEach((module, index) => {
		    console.log(this.$moduleSubs2ColsDesplegableElements[index])
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleSubs2ColsDesplegableElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		const moduleSubs2ColsDesplegable = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleSubs2ColsDesplegable[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleSubs2ColsDesplegableElements[index], { clearProps: true });
			}
        });

        moduleSubs2ColsDesplegable.addLabel('step1');
        moduleSubs2ColsDesplegable.to(this.$moduleSubs2ColsDesplegable[index], { opacity: 1, duration: 1 }, 'step1');
		moduleSubs2ColsDesplegable.to(this.$moduleSubs2ColsDesplegableElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationSubs2ColsDesplegable;
